<template>
  <section class="chart-area-wrap">
    <div class="container" v-if="mode == 'dashboard'">
      <div class="row">
        <div class="col-lg-5">
          <left-column />
        </div>
        <div class="col-lg-7">
          <right-column />
        </div>
      </div>
    </div>
    <full-sized v-if="mode !== 'dashboard'" />
  </section>
</template>

<script>
import LeftColumn from '@/components/Widgets/LeftColumn'
import RightColumn from '@/components/Widgets/RightColumn'
import FullSized from '@/components/FullSized'
import _ from 'lodash'
import injectInitialState from '@/utils/inject-initial-state'
import { getMetaSocialObject } from '@/utils/funcs'

export default {
  name: 'Home',
  components: {
    'left-column': LeftColumn,
    'right-column': RightColumn,
    'full-sized': FullSized,
  },
  data() {
    return {
      // mode: 'dashboard',
    }
  },
  computed: {
    mode() {
      return _.get(this, '$route.query.m', 'dashboard')
    },
  },
  methods: {
    loadData() {
      this.$store.commit('market/updateTicker', this.$route.params.ticker)
      this.$store.commit('market/updateMarket', this.$route.params.market)
      Promise.all([
        this.$store.dispatch('layout/updateAll'),
        ...[
          !this.$store.state.request.socket.ready &&
            this.$store.dispatch('request/socket/init'),
        ],
        this.$store.dispatch('request/socket/subscribe', {
          ticker: this.$store.state.market.ticker,
        }),
        this.$store.dispatch('targets/loadTargets'),
      ]).finally(() => {
        if (window.__PRERENDER_INJECTED) {
          const render = () => {
            injectInitialState(this.$store.state)
            document.dispatchEvent(new Event('prerender-now'))
          }
          setTimeout(render, 10000) //fallback
          const intID = setInterval(() => {
            if (this.$store.state.market.companyName != 'loading') {
              render()
              clearInterval(intID)
            }
          }, 100)
        }
      })
    },
    changeMode(mode) {
      this.mode = mode
    },
  },
  metaInfo() {
    const title = `${this.$store.state.market.companyName} ${this.$t(
      'messages.titlePostfix'
    )}`
    const desc = this.$store.state.market.companyDescription
    const url = process.env.VUE_APP_SITE_URL + this.$route.path
    return getMetaSocialObject(
      title,
      desc,
      url,
      `${process.env.VUE_APP_BACKOFFICE_URL}previews/dash/${this.$route.params.market}:${this.$route.params.ticker}` ||
        '/img/preview_default_ru.png'
    )
  },
  // mounted() {
  //   this.loadData()
  // },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm && to.params.ticker && to.params.market) vm.loadData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('request/socket/leave', {
      ticker: this.$store.state.market.ticker,
      market: this.$store.state.market.platform,
    })
    next()
  },
  watch: {
    $route() {
      this.$store.dispatch('request/socket/leave', {
        ticker: this.$store.state.market.ticker,
        market: this.$store.state.market.platform,
      })

      if (this.$route.params.ticker && this.$route.params.market)
        this.loadData()
    },
    '$i18n.locale'() {
      // this.$store.dispatch('news/updateAll', null)
      this.loadData()
    },
  },
}
</script>

<style lang="scss">
.chart-area-wrap {
  padding: 20px 0 20px 0;
  overflow: hidden;
  height: calc(100% - 146px);
  position: relative;

  &::after {
    content: '';
    position: fixed;
    width: 100%;
    height: 31px;
    @include gradient(360deg, #ffffff 50%, rgba(255, 255, 255, 0) 100%);
    bottom: 0;
    left: 0;
  }
  @media (max-width: 1240px) {
    overflow: auto;
  }

  @media (max-width: 1400px), (max-height: 800px) {
    height: auto !important;
  }
}

@media (max-width: 550px) {
  .left-chart-bottom,
  .right-top-chart {
    margin-bottom: 20px !important;
  }
}

.settings-tab {
  position: relative;

  .collapse:not(.show) {
    display: block !important;
    width: 100%;
    height: 0;
    border-color: transparent;
    overflow: hidden;

    .checkbox-animated {
      transform: translateX(30px);
      opacity: 0;
    }
  }

  &-text-icon {
    color: $primary-color2;
    font-size: 1.125rem;
    display: block !important;
    position: absolute;
    right: 0px;
    top: 0;
    z-index: 99;

    i.fa {
      display: block;
    }
    .btn-text {
      display: none;
      font-size: 1.125rem;
    }

    &.collapse:not(.show) {
      i.fa {
        display: none;
        &.chart {
          display: inline-block;
          width: 6rem;
          text-align: right;
        }
      }
      .btn-text {
        display: block;
        margin-top: -6px;
      }
    }
  }

  &-overlay {
    background-color: #fff;
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 999;
    top: 0px;
    left: 0;
    border: 1px dashed #c2c2d6;
    border-top: 0;
    overflow: hidden;
    box-sizing: border-box;
    @include transition();

    .checkbox-animated {
      transform: translateY(0);
      opacity: 1;
      @include transition();
      @include transition-delay(0.3s);
    }
  }
}

.checkbox-group {
  padding: 30px 20px 0;
  .checkbox-animated {
    position: relative;
    margin-bottom: 10px;

    input[type='checkbox'] {
      display: none;

      &:disabled ~ label .box {
        border-color: $primary-color2;
        background-color: #e6e6e6;
      }

      &:disabled ~ label .check {
        border-color: $primary-color2;
      }

      &:checked ~ label .box {
        opacity: 0;
        -webkit-transform: scale(0) rotate(-180deg);
        -moz-transform: scale(0) rotate(-180deg);
        transform: scale(0) rotate(-180deg);
      }

      &:checked ~ label .check {
        opacity: 1;
        -webkit-transform: scale(0.7) rotate(45deg);
        -moz-transform: scale(0.7) rotate(45deg);
        transform: scale(0.7) rotate(45deg);
      }
    }

    label {
      cursor: pointer;
      padding-left: 28px;
      font-weight: normal;
      margin-bottom: 0;

      & span {
        display: block;
        position: absolute;
        left: 0;
        -webkit-transition-duration: 0.3s;
        -moz-transition-duration: 0.3s;
        transition-duration: 0.3s;
      }

      & .box {
        border: 2px solid $primary-color2;
        height: 20px;
        width: 20px;
        z-index: 888;
        -webkit-transition-delay: 0.2s;
        -moz-transition-delay: 0.2s;
        transition-delay: 0.2s;
      }

      & .check {
        top: -7px;
        left: 6px;
        width: 12px;
        height: 24px;
        border: 2px solid $primary-color2;
        border-top: none;
        border-left: none;
        opacity: 0;
        z-index: 888;
        -webkit-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
        transform: rotate(180deg);

        -webkit-transition-delay: 0.3s;
        -moz-transition-delay: 0.3s;
        transition-delay: 0.3s;
      }
    }
  }

  .checkbox-animated-inline {
    @extend .checkbox-animated;

    &.checkbox-animated-inline {
      display: inline-block;
      & + .checkbox-animated-inline {
        margin-left: 10px;
      }
    }
  }
}

.chart-title,
.chart-title-2,
.single-items {
  .title-question-icon {
    opacity: 0;
    margin: 0 3px;
    @include transition();
    &:hover {
      cursor: pointer;
    }
    @media (max-width: 991px) {
      opacity: 1;
    }
  }
  &:hover .title-question-icon {
    opacity: 1;
  }
}

.chart-title-2 {
  border-bottom: 2px solid $title-color;
  padding-bottom: 8px;
  margin-bottom: 10px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h6 {
    font-size: 1rem;
    margin-bottom: 0;
  }

  p {
    color: $primary-color;
    margin-bottom: 0;
  }
}

.chart-title {
  font-size: 1rem;
  border-bottom: 2px solid $title-color;
  padding-bottom: 8px;
  margin-bottom: 10px;
  position: relative;

  .right-bar-icon {
    opacity: 0;
    @include transition();
    cursor: pointer;
  }
  &:hover .right-bar-icon {
    opacity: 1;
  }
}
</style>
